module.exports = __webpack_public_path__ + "static/img/logo2.a7b1b12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo2.png
// module id = /eIm
// module chunks = 11